import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import { BASE_IMAGES_URL, COMMON_FAIL_MESSAGE } from "Constants";
import {
  deleteSpeaker,
  deleteAssociatedAppuser,
  openSpeakerModal,
  loadSpeakerData,
  isimportant,
  updateSpeakersFiles,
  filesChanged,
} from "ActionsSpeakers";
import { checkContentDashboardStatus } from "GeneralTabAction";
import { showError, showSuccess } from "ReduxErrorBar";
import LocaleStrings from "Languages";

class ListItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      delLoading: false,
      delAssociatedUser: false,
    };
  }

  open = () => {
    this.setState({ showModal: true });
  };

  close = () => {
    this.setState({
      showModal: false,
      delLoading: false,
      delAssociatedUser: false,
    });
  };

  handleCheckbox = (e) => {
    var value = e.target.checked;
    this.setState({ delAssociatedUser: value });
  };

  deleteSpeakerCallback(speaker) {
    var { delAssociatedUser } = this.state;
    let pageNo = this.props.currentPage;
    if (this.props.pageDataLength == 1) {
      pageNo = pageNo - 1;
    }

    // confirmAlert({
    //   title: "Delete",
    //   message: LocaleStrings.content_spea_text_delete_spe,
    //   confirmLabel: "OK",
    //   cancelLabel: "CANCEL",
    //   onConfirm: () => {
    //     var speakerid = this.props.speaker.speakerid;
    //     this.props.deleteSpeaker(this.props.session, speakerid, (result) => {
    //       if (result.error) {
    //         this.props.showError(COMMON_FAIL_MESSAGE);
    //       } else {
    //         this.props.showSuccess("Speaker deleted successfully!");
    //         this.props.checkContentDashboardStatus(this.props.session);
    //         this.props.pagination(pageNo);
    //       }
    //     });
    //   },
    //   onCancel: () => {},
    // });

    var speakerid = this.props.speaker.speakerid;
    this.setState({ delLoading: true });
    if (delAssociatedUser === true) {
      this.props.deleteAssociatedAppuser(
        this.props.session,
        speakerid,
        (response) => {
          if (response.success === 0) {
            this.props.showError(LocaleStrings.speaker_error_message);
            this.setState({ delLoading: false });
          } else {
            this.props.deleteSpeaker(
              this.props.session,
              speakerid,
              (result) => {
                this.setState({ delLoading: false });
                if (result.error) {
                  this.props.showError(COMMON_FAIL_MESSAGE);
                } else {
                  this.close();
                  this.props.showSuccess(LocaleStrings.speaker_dlt_success);
                  this.props.checkContentDashboardStatus(this.props.session);
                  this.props.pagination(pageNo);
                }
              }
            );
          }
        }
      );
    } else {
      this.props.deleteSpeaker(this.props.session, speakerid, (result) => {
        this.setState({ delLoading: false });
        if (result.error) {
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          this.close();
          this.props.showSuccess(LocaleStrings.speaker_dlt_success);
          this.props.checkContentDashboardStatus(this.props.session);
          this.props.pagination(pageNo);
        }
      });
    }
  }

  editSpeakerCallback(obj) {
    var speaker = this.props.speaker;

    var fileName1 = "";
    var fileName2 = "";
    var fileName3 = "";
    var fileName4 = "";
    var fileName5 = "";
    if (speaker.file1) {
      var f1 = speaker.file1.split("/").pop();
      var f2 = f1.substr(0, f1.lastIndexOf("_"));
      var ext = f1.split(".").pop();

      fileName1 = f2 + "." + ext;
    }
    if (speaker.file2) {
      var f1 = speaker.file2.split("/").pop();
      var f2 = f1.substr(0, f1.lastIndexOf("_"));
      var ext = f1.split(".").pop();

      fileName2 = f2 + "." + ext;
    }
    if (speaker.file3) {
      var f1 = speaker.file3.split("/").pop();
      var f2 = f1.substr(0, f1.lastIndexOf("_"));
      var ext = f1.split(".").pop();

      fileName3 = f2 + "." + ext;
    }
    if (speaker.file4) {
      var f1 = speaker.file4.split("/").pop();
      var f2 = f1.substr(0, f1.lastIndexOf("_"));
      var ext = f1.split(".").pop();

      fileName4 = f2 + "." + ext;
    }
    if (speaker.file5) {
      var f1 = speaker.file5.split("/").pop();
      var f2 = f1.substr(0, f1.lastIndexOf("_"));
      var ext = f1.split(".").pop();

      fileName5 = f2 + "." + ext;
    }
    var files = [
      {
        position: "file1",
        file: speaker.file1 ? speaker.file1 : "",
        filename: fileName1,
      },
      {
        position: "file2",
        file: speaker.file2 ? speaker.file2 : "",
        filename: fileName2,
      },
      {
        position: "file3",
        file: speaker.file3 ? speaker.file3 : "",
        filename: fileName3,
      },
      {
        position: "file4",
        file: speaker.file4 ? speaker.file4 : "",
        filename: fileName4,
      },
      {
        position: "file5",
        file: speaker.file5 ? speaker.file5 : "",
        filename: fileName5,
      },
    ];
    this.props.loadSpeakerData(speaker);
    this.props.openSpeakerModal({ showModal: true });
    this.props.updateSpeakersFiles(files);
    this.props.filesChanged({ ischanged: false });
  }

  important = () => {
    let { speaker, session } = this.props;
    let imp = true;
    if (speaker && speaker.featured) {
      imp = false;
    }

    this.props.isimportant(session, speaker, imp, (response) => {
      if (!response.success) {
        this.props.showError(COMMON_FAIL_MESSAGE);
      } else {
        this.props.operationsCallback();
      }
    });
  };

  selectionCallback = (user) => {
    // var user = this.props.appUser;
    this.props.checkAndUncheckUsers(user);
  };

  render() {
    var { speaker, session, selectedUsers } = this.props;
    var { showModal, delLoading } = this.state;
    var index = _.findIndex(selectedUsers, function (curuser) {
      return curuser.speakerid === speaker.speakerid;
    });

    var checked = false;
    if (index >= 0) {
      checked = true;
    }

    var imgURL = "../../style/images/placeholder_600x400.svg";
    if (
      speaker.profileimage !== "" &&
      speaker.profileimage !== undefined &&
      speaker.profileimage !== null
    )
      imgURL = `${BASE_IMAGES_URL}/${speaker.profileimage}?api_key=${session.apiKey}&session_token=${session.sessionToken}`;

    var iconURL = `../../style/images/custom-icons/compound-shape.svg`;
    if (speaker.featured) {
      iconURL = `../../style/images/custom-icons/compound-shape-copy.svg`;
    }

    var style = {
      marginTop: "1px",
      width: "30px",
      height: "30px",
      backgroundImage: `url(${imgURL})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      borderRadius: "5px",
      backgroundPosition: "50% 50%",
    };

    var name = `${speaker.firstname} ${speaker.lastname}`;
    return (
      <tr key={speaker.speakerid}>
        <td>
          <label
            className="custom-container-checkbox"
            style={{ marginTop: -1 }}
          >
            <input
              type="checkbox"
              onChange={() => this.selectionCallback(speaker)}
              checked={checked}
            />
            <span className="checkmark" />
          </label>
        </td>
        <td width="40%">
          <div className="d-flex">
            <div style={style}></div>
            <div className="pt-5 pl-15 pr-15">
              <img
                onClick={this.important}
                className="i-custom-star pointer"
                src={iconURL}
              />
            </div>
            <div className="vcenter">{name}</div>
          </div>
        </td>
        <td>{speaker.company}</td>
        <td>{speaker.position}</td>
        <td>
          <div className="action-button-area">
            <div className="action-button vcenter">
              <button
                className="btn btn-custom-table-white"
                onClick={this.editSpeakerCallback.bind(this)}
              >
                {LocaleStrings.button_edit}
              </button>
            </div>
            <div className="action-button vcenter">
              <button className="i-custom-table-delete" onClick={this.open}>
                <img
                  className="button-delete-icon"
                  src="../../style/images/delete.png"
                />
              </button>
            </div>
          </div>

          {showModal === true ? (
            <Modal
              className="modal-container"
              show={showModal === true ? true : false}
              onHide={this.close}
              animation={true}
              keyboard={false}
              backdrop="static"
              dialogClassName="modal-md"
              enforceFocus={false}
            >
              <Modal.Header>
                <div className="import-modal-title">{`Delete Speaker`}</div>
                <button
                  type="button"
                  className="i-custom-cross-popup pull-right"
                  onClick={() => this.close()}
                >
                  <img
                    className="i-custom-small"
                    src="../../style/images/custom-icons/cross-black.png"
                  />
                </button>
              </Modal.Header>
              <Modal.Body>
                <div className="form-group">
                  <p>{LocaleStrings.content_spea_text_delete_spe}</p>
                  <p>
                    {
                      LocaleStrings.content_common_text_delete_associated_user_confirm
                    }
                  </p>
                </div>
                <div className="form-group">
                  <label
                    htmlFor="deleteassociateduser"
                    className="custom-container-checkbox"
                  >
                    {LocaleStrings.content_common_text_delete_associated_user}
                    <input
                      type="checkbox"
                      id="deleteassociateduser"
                      name="deleteassociateduser"
                      // value={true}
                      onChange={this.handleCheckbox}
                    />
                    <span className="checkmark" />
                  </label>
                  <p>
                    {
                      LocaleStrings.content_common_text_delete_associated_user_note
                    }
                  </p>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button className="btn btn-custom-white" onClick={this.close}>
                  {LocaleStrings.button_cancel}
                </Button>
                <Button
                  className="btn btn-custom-blue ml-10"
                  type="button"
                  loading={delLoading}
                  onClick={this.deleteSpeakerCallback.bind(this)}
                  disabled={delLoading}
                >
                  {LocaleStrings.button_delete}
                </Button>
              </Modal.Footer>
            </Modal>
          ) : (
            ""
          )}
        </td>
      </tr>
    );
  }
}
function mapStateToProps(state) {
  return {
    session: state.session,
  };
}
export default connect(mapStateToProps, {
  deleteSpeaker,
  deleteAssociatedAppuser,
  openSpeakerModal,
  loadSpeakerData,
  showError,
  showSuccess,
  checkContentDashboardStatus,
  isimportant,
  updateSpeakersFiles,
  filesChanged,
})(ListItem);
